import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import moment from "moment-timezone";

import {AppData, Route} from "v2/api/Records";
import {
  filterRoutesByGardenerOrType,
} from "v2/api/Routes";

import Empty from "v2/components/Empty";
import Loading from "v2/components/Loading";
import RouteCheckInOrderIcon from "v2/components/RouteCheckInOrderIcon";
import RouteBalanceIcon from "v2/components/RouteBalanceIcon";
import RouteDelay from "v2/components/RouteDelay";
import RouteLink from "v2/components/RouteLink";
import RouteReadOnlyIcon from "v2/components/RouteReadOnlyIcon";
import styles from "v2/styles";

const RoutesGroups = (props, context) => {
  if (!props.data) {
    return <Loading />;
  }

  const {
    appData: {serviceType},
    location: {query: {q: search}},
  } = context;
  const {heightDiff, sidebar} = props;

  const data = filterRoutesByGardenerOrType(
    props.data,
    search,
    serviceType);

  if (!data.size) {
    const content = [
      "No routes",
      search && <span key="query"> found for <strong><em>{search}</em></strong></span>,
      ".",
    ].filter(item => item);
    return <Empty>{content}</Empty>;
  }

  const dataByType = data.groupBy(item => item.type);
  const routesByType = serviceType
    .keySeq()
    .map(key => dataByType.get(key))
    .filter(item => item);

  const routesGroups = routesByType.map((routes, idx) => {
    const {type} = routes.first();

    const wrapperClassName = sidebar ?
      "erg-sidebar-group clearfix" :
      "erg-padding-15";
    const wrapperStyle = !sidebar && idx !== routesByType.length - 1 ?
      {borderBottom: styles.BORDER} :
      {};

    const titleClassName = !sidebar ? "erg-margin-top-15" : null;
    const titleStyle = !sidebar ? {
      overflow: "hidden",
      textTransform: "uppercase",
    } : null;

    let content;
    if (sidebar) {
      content = (
        <ul>
          {routes.map(route => (
            <li key={`route-${route.id}`}>
              <RouteLink route={route} />
              <RouteDelay delay={route.delay} showTime={false} />
            </li>
          ))}
        </ul>
      );
    } else {
      content = (
        <div className="row">
          {routes.map(route => (
            <div
              className="col-xs-12 col-sm-6 col-md-4"
              key={`route-${route.id}`}>
              <RouteLink route={route} />
              <RouteBalanceIcon
                balance={route.balance}
                className="erg-margin-left-15 erg-font-xs"
                visible={moment(route.date).isAfter(moment(), "day")} />
              <RouteCheckInOrderIcon
                className="erg-margin-left-15 erg-font-sm"
                isValid={route.correctCheckinOrder} />
              <RouteReadOnlyIcon
                className="erg-margin-left-15 erg-font-sm"
                visible={route.readOnly} />
              <RouteDelay className="erg-margin-left-15" delay={route.delay} />
            </div>
          ))}
        </div>
      );
    }
    return (
      <div
        className={wrapperClassName}
        key={`${type}-routes`}
        style={wrapperStyle}>
        <h5 className={titleClassName} style={titleStyle}>
          {serviceType.get(type)}
        </h5>
        {content}
      </div>
    );
  });

  return (
    <div style={sidebar ? styles.scrollableSidebar(heightDiff) : {}}>
      {routesGroups}
    </div>
  );
};

RoutesGroups.contextTypes = {
  appData: PropTypes.instanceOf(AppData),
  location: PropTypes.object,
};
RoutesGroups.defaultProps = {
  sidebar: false,
};
RoutesGroups.propTypes = {
  data: ImmutablePropTypes.listOf(PropTypes.instanceOf(Route)),
  heightDiff: PropTypes.number,
  sidebar: PropTypes.bool,
};

export default RoutesGroups;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/RoutesGroups.js
 **/